module.exports = supplierMapping;